export const showNavMenuSelector = ({showNavMenu}) => showNavMenu